import {Helmet} from '@dr.pogodin/react-helmet';
import {match} from 'ts-pattern';

import {isString} from 'ramda-adjunct';

import i18n from '@dms/i18n';
import {testIds, warehouseRoutes} from '@dms/routes';
import {catchUnhandledDataGridActions, DmsDataGrid, logError, Main} from '@dms/shared';
import {FullscreenDataGridWrapper} from '@dms/warehouse/shared-components';

import {composePath, useNavigate} from 'shared/web';

import type {ActionCallback} from 'features/eag-grid';

const CORE_EXCHANGE_GRID_CODE = 'warehouse-core-exchange';

export function CoreExchangeList() {
  const navigate = useNavigate();

  const actionCallback: ActionCallback = ({actionKey, rowId, sourceSearchParams}) => {
    if (!isString(rowId)) {
      return logError(`Bulk invocation of single-row action ${actionKey} is not implemented`);
    }

    match(actionKey)
      .with('edit', 'redirectDetail', () =>
        navigate(
          composePath(warehouseRoutes.coreExchangeDetailOverview, {
            params: {id: rowId},
            queryParams: sourceSearchParams,
            isSearchParamsPreserved: false,
          })
        )
      )
      .otherwise(() => catchUnhandledDataGridActions(actionKey));
  };

  return (
    <>
      <Helmet title={i18n.t('module.warehouse.title')} />
      <Main isFullHeight heading={i18n.t('page.warehouse.labels.coreExchanges')}>
        <FullscreenDataGridWrapper hideCardWrapper>
          <DmsDataGrid
            gridCode={CORE_EXCHANGE_GRID_CODE}
            actionCallback={actionCallback}
            data-testid={testIds.warehouse.coreExchanges('datagrid')}
          />
        </FullscreenDataGridWrapper>
      </Main>
    </>
  );
}
